import script from "./HistoricProjectReviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoricProjectReviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HistoricProjectReviewComponent.vue?vue&type=style&index=0&id=35e91458&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e91458"]])

export default __exports__